import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';
import i18n from 'kodyl-js/i18n/react';
import DocumentMeta from 'react-document-meta';
import Markdown from '../static/markdown';

const md = `
# Ofte stillede spørgsmål

## Log ind og adgangskode

### Jeg har glemt min adgangskode
Hvis du har glemt din adgangskode, kan du nulstille den. Klik på ‘glemt adgangskode’ ved log ind og indtast derefter din e-mail adresse. Du vil derefter få tilsendt en mail med et link til at ændre din adgangskode.

### Jeg kan ikke huske hvilken mail, jeg oprettede mig med
Er du i tvivl om hvilken e-mail, du har oprettet dig med, så kontakt kundeservice.

### Jeg har fået ny e-mail adresse, kan jeg selv ændre den?
Ja, i menuen under rediger profil kan du redigere din e-mail. Her kan du også redigere navn, adgangskode og boligagenter. Når du har indtastet din nye e-mail, sender vi en bekræftelseskode til e-mailadressen, som du skal indtaste for at bekræfte din nye e-mailadresse.


## Boligsøgning

### Kan Boligninja.dk svare på spørgsmål om konkrete lejemål?
Nej, vi kan desværre ikke svare på konkrete spørgsmål om de enkelte lejemål. Boligerne på Boligninja.dk kommer fra en lang række professionelle udlejere, og spørgsmålene skal rettes til disse. Kontaktoplysninger på udlejer finder du i den enkelte boligannonce. For at få adgang til kontaktoplysningerne kræver det blot, at du opretter en Boligsøgerannonce.

### Hvordan kontakter jeg udlejer?
Du finder kontaktoplysninger på udlejer i den enkelte boligannonce. For at få adgang til kontaktoplysningerne kræver det blot, at du opretter en Boligsøgerannonce.

### Jeg kan ikke se udlejers telefonnummer eller email.
Du kan se kontaktoplysningerne på udlejer, så snart du har oprettet en Boligsøgerannonce.

### Jeg søger kun lejemål, hvor husdyr er tilladt, hvordan ser jeg det ved de enkelte lejemål?
Hvis det ikke står oplyst under den enkelte annonce, så henvend dig direkte til udlejer.


### Jeg har et spørgsmål der ikke fremgår af FAQ (Ofte stillede spørgsmål), hvad gør jeg?
Hvis du har et spørgsmål, der ikke blev besvaret i vores FAQ, er du selvfølgelig meget velkommen til at skrive til os på info (a) boligninja.dk


## Abonnement og e-mails

### Hvad koster det at benytte Boligninja.dk?
Det er gratis at have en bruger på Boligninja.dk og gratis at benytte vores BoligAgent e-mail-service, som sørger for at give dig besked, så snart et nyt ledigt lejemål, der lever op til dine krav, annonceres. For at få adgang til udlejers kontaktoplysninger, kræver det dog. at du har en Boligsøgerannonce. Priser og vilkår for abonnement på Boligsøgerannonce fremgår på abonnementssiden for din profil.

### Hvor finder jeg kvitteringen for mit køb?
Du finder kvitteringen for dit køb af en boligersøgerannonce under abonnement i menuen

### Hvor finder jeg mit ordrenummer?
Dit ordrenummer er det 4-cifrede nummer, som står oplyst under abonnement i menuen.

### Jeg vil gerne have en email, når en bolig matcher mine krav
Hvis du allerede har oprettet en bruger, bliver der automatisk oprettet en boligagent, når du bruger søgefunktionen på forsiden. Boligagenten sørger for at du modtager en mail, når nye lejemål, der matcher din søgning, annonceres. Du kan oprette så mange boligagenter, som du vil. Du kan rette og slette dine boligagenter under rediger profil i menuen.

### Hvordan afmelder jeg e-mails/boligagenter?
Du kan rette og slette dine boligagenter under rediger profil i menuen. Du kan også afmelde boligagenter ved at klikke på linket i bunden af de mails, som du modtager fra boligagenten.

### Jeg har oprettet mig som bruger, men modtager ingen e-mails fra jer?
Har du hverken modtaget en bekræftelsesmail ved oprettelsen af din bruger, eller mails vedrørende ledige lejemål, så dobbelttjek gerne hvilken e-mailadresse, du har benyttet til at oprette din profil. Tjek også gerne dit spam-filter. Det kan ske at vores e-mails til dig er havnet der.

### Hvordan afmelder jeg min Boligersøgerannonce?
Du kan afmelde din Boligersøgerannonce her [https://www.boligninja.dk/info/afmelding](/info/afmelding) eller ved at klikke på abonnement i menuen.
`;

@i18n
class Faq extends Component {
  render() {
    const docMeta = {
      title: this.i18n('FAQ'),
      extend: true,
      auto: {
        ograph: true
      }
    };

    return (
      <DocumentMeta {...docMeta}>
        <Grid>
          <Row>
            <Col xs={12} className="markdown">
              <Markdown source={md} />
            </Col>
          </Row>
        </Grid>
      </DocumentMeta>
    );
  }
}

export default Faq;
